import './ListScreenSkeleton.css';

const ListScreenSkeleton = () => {
  const rows = Array.from({ length: 5 });
  const columns = Array.from({ length: 5 });

  return (
    <div className="skeleton-list-screen">
      <div className="skeleton-heading-row">
        <div className="skeleton-heading"></div>
        <div className="skeleton-button"></div>
      </div>

      <div className="skeleton-filter-section">
        <div className="skeleton-search-input"></div>
        <div className="skeleton-filter-item"></div>
        <div className="skeleton-filter-item"></div>
        <div className="skeleton-search-button"></div>
        <div className="skeleton-columns-button"></div>
      </div>

      <div className="skeleton-table-container">
        <table>
          <thead>
            <tr>
              {columns.map((_, index) => (
                <th key={`header-${index}`}>
                  <div className="skeleton-cell"></div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((_, rowIndex) => (
              <tr key={`row-${rowIndex}`}>
                {columns.map((_, colIndex) => (
                  <td key={`cell-${rowIndex}-${colIndex}`}>
                    <div className="skeleton-cell"></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="skeleton-pagination-section">
        <div className="skeleton-pagination-info"></div>
        <div className="skeleton-pagination-controls">
          <div className="skeleton-pagination-control-item"></div>
          <div className="skeleton-pagination-control-item"></div>
          <div className="skeleton-pagination-control-input"></div>
          <div className="skeleton-pagination-control-item"></div>
          <div className="skeleton-pagination-control-item"></div>
        </div>
      </div>
    </div>
  );
};

export default ListScreenSkeleton;